import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { FAQ_ITEMS } from '../mock';
import { HelpCircle } from 'lucide-react';

export const FAQSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            FAQ
          </div>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Alles Wichtige rund um Unfallgutachten auf einen Blick
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl p-10 lg:p-16 shadow-modern-lg">
          <Accordion type="single" collapsible className="w-full space-y-5">
            {FAQ_ITEMS.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="border border-gray-200 rounded-2xl px-7 py-1 data-[state=open]:border-brand-green/40 data-[state=open]:shadow-xl transition-all bg-white"
              >
                <AccordionTrigger className="text-left font-bold text-gray-900 hover:text-brand-green py-6 hover:no-underline text-base lg:text-lg">
                  <div className="flex items-start gap-4">
                    <HelpCircle className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" />
                    <span className="pr-4">{item.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6 pl-10 text-[15px]">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};